<script lang="ts">
	import PolicyPage from '$lib/components/PolicyPage.svelte';
</script>

<PolicyPage title="Cookie Policy" description="How healthyshoes.com.cy uses cookies. We only store a language preference — no tracking, no analytics, no advertising cookies.">
	<p>
		We keep things simple. We set one cookie, use your browser's local storage for
		essential shopping functionality, and do not track you in any way.
	</p>

	<h2>What We Store</h2>
	<p>
		We set a single cookie on our site:
	</p>
	<ul>
		<li>
			<strong>Language preference</strong> (<code>PARAGLIDE_LOCALE</code>) —
			remembers your chosen language so the site loads correctly on your next visit.
		</li>
	</ul>
	<p>
		We also use your browser's local storage (not cookies) for:
	</p>
	<ul>
		<li><strong>Shopping cart ID</strong> — so your cart persists between visits</li>
		<li><strong>Account session</strong> — if you log in to your account</li>
	</ul>
	<p>
		None of these are used for tracking or advertising. They exist solely to make the site work.
	</p>

	<h2>No Tracking</h2>
	<p>
		There is no Google Analytics, Facebook Pixel, or any other analytics or advertising
		tracker on this site. We do not collect or share browsing data with third parties.
	</p>

	<h2>Shopify</h2>
	<p>
		Our checkout is powered by Shopify. When you proceed to checkout, Shopify may set
		its own cookies to process your order and payment securely. These are managed by Shopify,
		not by us. For details, see
		<a href="https://www.shopify.com/legal/cookies" target="_blank" rel="noopener">Shopify's Cookie Policy</a>
		and
		<a href="https://www.shopify.com/legal/privacy" target="_blank" rel="noopener">Shopify's Privacy Policy</a>.
	</p>

	<h2>Google Maps</h2>
	<p>
		Our <a href="/find-us">Find Us</a> page includes an embedded Google Map.
		Google may set cookies when the map loads. See
		<a href="https://policies.google.com/privacy" target="_blank" rel="noopener">Google's Privacy Policy</a>
		for details.
	</p>

	<h2>Managing Storage</h2>
	<p>
		You can clear cookies and local storage at any time through your browser settings.
		Note that clearing local storage will reset your shopping cart.
	</p>

	<h2>Contact</h2>
	<p>
		If you have questions, contact us at
		<a href="mailto:info@orthohouse.com.cy">info@orthohouse.com.cy</a>.
	</p>
</PolicyPage>
